var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgYoutubeGradient = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 101,
    viewBox: "0 0 95 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.7393V70.4238C5.43709e-05 72.2345 0.502523 74.0134 1.45692 75.5814C2.41132 77.1497 3.78405 78.4518 5.43709 79.3572L41.6643 99.1995C43.3175 100.105 45.1927 100.582 47.1014 100.582C49.0104 100.582 50.8853 100.105 52.5385 99.1995L88.7658 79.3572C90.419 78.4518 91.7916 77.1497 92.746 75.5814C93.7005 74.0134 94.2029 72.2345 94.2029 70.4238V30.7393C94.2029 28.9286 93.7005 27.1497 92.746 25.5817C91.7916 24.0134 90.419 22.7112 88.7658 21.8059L52.5385 1.96358C50.8853 1.05819 49.0104 0.581543 47.1014 0.581543C45.1927 0.581543 43.3175 1.05819 41.6643 1.96358L5.43709 21.8059C3.78405 22.7112 2.41132 24.0134 1.45692 25.5817C0.502523 27.1497 5.43709e-05 28.9286 0 30.7393Z",
    fill: "#4375C5",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16541 74.5417L3.16533 74.5415C2.39889 73.2823 2.00004 71.8624 2 70.4238V30.7393C2 30.7393 2 30.7393 2 30.7393C2.00005 29.3006 2.39891 27.8807 3.16533 26.6215L3.16541 26.6214C3.93246 25.361 5.04374 24.3016 6.39784 23.56L5.43709 21.8059L6.39785 23.56L42.625 3.71773C43.9798 2.97577 45.5241 2.58154 47.1014 2.58154C48.679 2.58154 50.223 2.97576 51.5778 3.71773L87.805 23.56L87.8051 23.56C89.1592 24.3016 90.2704 25.361 91.0376 26.6215L91.0377 26.6216C91.8041 27.8807 92.2029 29.3006 92.2029 30.7393V70.4238C92.2029 71.8625 91.8041 73.2824 91.0377 74.5415L91.0376 74.5416C90.2704 75.8021 89.1593 76.8614 87.805 77.6031L51.5777 97.4454C50.223 98.1874 48.6791 98.5815 47.1014 98.5815C45.524 98.5815 43.9798 98.1874 42.6251 97.4454L6.3979 77.6031C6.39789 77.6031 6.39787 77.6031 6.39785 77.6031C5.04368 76.8613 3.93242 75.802 3.16541 74.5417Z",
    stroke: "url(#paint0_linear_13440_32904)",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4118 45.21C66.4118 40.4396 62.5908 36.5742 57.8752 36.5742H36.0737C31.3581 36.5742 27.5371 40.4396 27.5371 45.21V55.4747C27.5371 60.245 31.3581 64.1105 36.0737 64.1105H57.888C62.6035 64.1105 66.4246 60.245 66.4246 55.4747V45.21H66.4118ZM53.5814 51.118L43.8052 56.0176C43.4218 56.2245 42.1183 55.9401 42.1183 55.5005V45.4427C42.1183 44.9902 43.4346 44.7187 43.818 44.9385L53.1852 50.0967C53.5814 50.3165 53.9903 50.8982 53.5941 51.118H53.5814Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13440_32904",
    x1: -0.00000185583,
    y1: 0.342359,
    x2: 114.592,
    y2: 63.1307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#4195D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4195D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4195D2",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgYoutubeGradient);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/youtube_gradient.c031ef4ce732a319eef88386a7dd8088.svg";